import { MapPin, Clock, Phone, MessageCircle, CarFront } from "lucide-react";
import { LogoMark } from "./Logo";
import { useLang } from "../i18n";

export function Footer() {
    const { t } = useLang();
    return (
        <footer className="relative overflow-hidden border-t border-white/10 bg-[#08080b] pt-20" data-testid="footer-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <div className="flex flex-wrap items-start justify-between gap-10 pb-16">
                    <div className="max-w-sm">
                        <div className="flex items-center gap-3">
                            <LogoMark size={44} />
                            <div>
                                <p className="font-display text-lg font-extrabold">
                                    9CUT <span className="text-[#FFB800]">SALON</span>
                                </p>
                                <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#8E8EA0]">{t.brandSub}</p>
                            </div>
                        </div>
                        <p className="mt-5 text-sm leading-relaxed text-[#8E8EA0]">{t.hero.sub}</p>
                    </div>
                    <div className="space-y-4 text-sm">
                        <p className="flex items-center gap-3 text-[#c9c9d4]">
                            <Clock size={16} className="text-[#FFB800]" />
                            {t.footer.hours}
                        </p>
                        <p className="flex items-center gap-3 text-[#c9c9d4]">
                            <MapPin size={16} className="text-[#FFB800]" />
                            <a
                                href="https://www.google.com/maps/search/?api=1&query=84+Winmalee+Dr+Glen+Waverley+VIC+3150"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="hover:text-[#FFB800] transition-colors"
                            >
                                {t.footer.addr}
                            </a>
                        </p>
                        <p className="flex items-center gap-3 text-[#c9c9d4]">
                            <Phone size={16} className="text-[#FFB800]" />
                            <a href="tel:+61426785250" className="hover:text-[#FFB800] transition-colors">
                                {t.footer.contact} · 0426 785 250
                            </a>
                        </p>
                        <p className="flex items-center gap-3 text-[#c9c9d4]">
                            <MessageCircle size={16} className="text-[#FFB800]" />
                            WeChat: koonkian215
                        </p>
                        <p className="flex items-center gap-3 text-[#c9c9d4]">
                            <CarFront size={16} className="text-[#FFB800]" />
                            {t.footer.parking}
                        </p>
                    </div>
                </div>
            </div>
            <p aria-hidden className="pointer-events-none select-none text-center font-display text-[18vw] font-extrabold leading-[0.8] tracking-tighter text-stroke-amber opacity-25">
                9CUT
            </p>
            <div className="border-t border-white/10 py-6 text-center font-mono2 text-xs text-[#4a4a58]">{t.footer.rights}</div>
        </footer>
    );
}
